import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const TwitterWhite = forwardRef<SVGSVGElement, IconProps>(({ size = 20 }, forwardedRef) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 38 35"
      fill="none"
      ref={forwardedRef}
    >
      <g filter="url(#a)">
        <path
          fill="#fff"
          fillRule="evenodd"
          d="m24.15 8.204-5.435 6.365-4.342-6.365H8.346l7.018 10.288-7.114 8.33h2.452l5.75-6.734 4.594 6.734h6.027l-7.27-10.657 6.799-7.96H24.15Zm-2.015 16.81-4.525-6.519-5.85-8.43h1.511l10.375 14.95h-1.511Z"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <filter
          id="a"
          width="46"
          height="46"
          x="-5"
          y="-4"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_5481_113070" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_5481_113070" result="shape" />
        </filter>
      </defs>
    </svg>
  )
})
